var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuFolder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:red;}.cls-2{fill:none;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "menu_folder") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_2-2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M129.86,35.22H71.39v-10a6.1,6.1,0,0,0-6.09-6.1H20.92a6.1,6.1,0,0,0-6.09,6.1V120a6.1,6.1,0,0,0,6.09,6.1H129.86A6.11,6.11,0,0,0,136,120V41.32A6.11,6.11,0,0,0,129.86,35.22ZM131.92,120a2.06,2.06,0,0,1-2.06,2.06H20.92A2.06,2.06,0,0,1,18.86,120V57.43H131.92ZM18.86,53.39V25.17a2.06,2.06,0,0,1,2.06-2.06H65.3a2.06,2.06,0,0,1,2.06,2.06V39.26h62.5a2.06,2.06,0,0,1,2.06,2.06V53.39Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 150,
    height: 150
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuFolder);
export default __webpack_public_path__ + "static/media/menu_folder.bc1f112d.svg";
export { ForwardRef as ReactComponent };